import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  CustomModal,
  InputText,
  CustomCalendar,
  InputPlacaVeiculo,
  Btn,
  SelectEmpresas,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useOcPrevistaModal, { LOAD_MESSAGE } from './OcPrevistaModalHook'
import { errorHandler } from '../../../../../services/util/error.service'

function OcPrevistaModal({ show, data, onModalClose, onModalSave, selectedTp, dispatch }) {
  const { state, localDispatch } = useOcPrevistaModal()

  useEffect(() => {
    if (show) localDispatch.start(data, selectedTp)
  }, [show, data, selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Salvando ordem de carregamento prevista', 'Aguarde...'))
        localDispatch
          .save(selectedTp)
          .then(saved => {
            dispatch(hideLoadingBox())
            dispatch(showMessageBox('Salvo com sucesso', null))
            onModalSave(saved)
          })
          .catch(err => {
            dispatch(hideLoadingBox())
            dispatch(showMessageBox(null, errorHandler(err)))
          })
        break
      default:
        break
    }
  }, [state.loadingMessage])

  return (
    <CustomModal
      header="Ordem de Carregamento - Prevista"
      isVisible={show}
      onClose={onModalClose}
      width={700}
    >
      <div className="p-grid">
        <div className="p-col-6">
          <SelectEmpresas
            companyId={state.item.company_id || null}
            onChange={empresa => localDispatch.onChange('company_id', empresa ? empresa.id : null)}
          />
        </div>
        <div className="p-col-6"></div>

        <div className="p-col-6">
          <InputText
            label="Destino:*"
            value={state.item.destino || ''}
            onChange={v => localDispatch.onChange('destino', v || '')}
          />
        </div>

        <div className="p-col-6">
          <InputText
            label="Código da OC:"
            value={state.item.oc_code || ''}
            onChange={v => localDispatch.onChange('oc_code', v || null)}
          />
        </div>

        <div className="p-col-4">
          <InputText
            label="Lacre:"
            value={state.item.lacre || ''}
            onChange={v => localDispatch.onChange('lacre', v || null)}
          />
        </div>

        <div className="p-col-4">
          <InputPlacaVeiculo
            label="Placa:"
            value={state.item.placa || ''}
            onChange={v => localDispatch.onChange('placa', v || null)}
          />
        </div>

        <div className="p-col-6">
          <CustomCalendar
            label="Data Expedição:"
            value={state.item._data_expedicao || null}
            onChange={v => localDispatch.onChange('_data_expedicao', v || null)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(OcPrevistaModal)
